import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'

interface CompetencyAreaCardProps {
  title: string
  description: string
  completed: number
  total: number
  onClick?: () => void
}

const CompetencyAreaCard = ({
  title,
  description,
  completed,
  total,
  onClick,
}: CompetencyAreaCardProps) => {
  const progress = total > 0 ? Math.round((completed / total) * 100) : 0

  return (
    <div
      className="card shadow-sm gw-competency-area-card"
      role={onClick ? 'button' : undefined}
      onClick={onClick}
    >
      <div className="card-body gw-competency-area-body">
        <div className="d-flex justify-content-between align-items-start gap-3">
          <div className="flex-grow-1">
            <div className="d-flex align-items-center gap-2 flex-wrap">
              <h6 className="gw-competency-area-title mb-0">{title}</h6>
              <span className="gw-competency-area-subtitle">
                {completed} of {total} completed
              </span>
            </div>
            <p className="gw-competency-area-description mb-3">{description}</p>
            <div className="d-flex align-items-center gap-2">
              <div className="gw-competency-area-progress">
                <div
                  className="gw-competency-area-progress-bar"
                  style={{ width: `${progress}%` }}
                />
              </div>
              <div className="gw-competency-area-percentage">{progress}%</div>
            </div>
          </div>
          <FontAwesomeIcon icon={faChevronRight} className="gw-competency-area-icon" />
        </div>
      </div>
    </div>
  )
}

export default CompetencyAreaCard
